import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer.tsx";
import { useQuery } from "@tanstack/react-query";
import {
  fetchContact,
  fetchContactBunner,
  fetchContactSeo,
  fetchTranslates,
} from "../Services/Requests.js";
import { useRecoilValue } from "recoil";
import { Languege } from "../Atom/index.js";
import Loading from "../components/Loading.tsx";
import { Helmet } from "react-helmet-async";
interface ContactInfoProps {
  title: string;
  value: string;
}

interface ContactSectionProps {
  contactInfo: ContactInfoProps[];
}

export default function Contact() {
  const [language, setLanguie] = useRecoilValue(Languege);

  const {
    data: Translates,
    isLoading: loadingTranslates,
    error: errorTranslates,
  } = useQuery({
    queryKey: ["Translates", language],
    queryFn: fetchTranslates,
  });
  const {
    data: ContactBunner,
    isLoading: loadingContactBunner,
    error: errorContactBunner,
  } = useQuery({
    queryKey: ["ContactBunner", language],
    queryFn: fetchContactBunner,
  });
  const {
    data: Contact,
    isLoading: loadingContact,
    error: errorContact,
  } = useQuery({
    queryKey: ["Contact", language],
    queryFn: fetchContact,
  });
    const {
    data: ContactSeo,
    isLoading: loadingContactSeo,
    error: errorContactSeo,
  } = useQuery({
    queryKey: ["ContactSeo", language],
    queryFn: fetchContactSeo,
  });
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    // Function to update scroll position
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    // Attach scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  if (loadingContactBunner || loadingContact) return <Loading />;
  if (errorContactBunner || errorContact) return <div>Error loading data</div>;
console.log(ContactSeo,"ContactSeo")
  return (
    <>
      <Helmet>
        {ContactSeo?.title && (
          <title>{ContactSeo?.title}</title>
        )}
        {ContactSeo?.description && (
          <meta name="description" content={ContactSeo?.description} />
        )}
      </Helmet>
      <div className="bg-white  relative  lg:overflow-hidden overflow-hidden   w-[100%] h-fit">
        <Header />

        <section
          className="flex  min-h-[420px] overflow-hidden flex-col items-center w-full text-white bg-black bg-opacity-70 max-md:max-w-full bg-cover bg-center"
          style={{
            backgroundImage: `url('https://admin.regional-group.com/storage/${ContactBunner.data[0].image}')`,
          }}
        >
          <div className="w-full  min-h-[420px] h-full  bg-black bg-opacity-70 flex justify-center items-center">
            <div className="flex flex-col mb-0 max-w-full w-[856px] max-md:mb-2.5 justify-center">
              <div className="flex flex-col w-full text-center max-md:max-w-full justify-center items-center">
                <h1 className="text-5xl font-semibold max-md:max-w-full max-md:text-4xl">
                  {ContactBunner.data[0].title}
                </h1>
                <div
                  className="text-lg leading-6 max-md:max-w-full mt-5 pl-2 pr-2"
                  dangerouslySetInnerHTML={{
                    __html: ContactBunner.data[0].description,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </section>
        <main className="z-10 w-full max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col">
            <div className="flex flex-col w-[80%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col mt-24 mr-0 w-full max-md:mt-10 max-md:max-w-full">
                <div className=" flex lg:flex-row-reverse flex-col lg:justify-end justify-start gap-6 ">
                  <div className="flex items-center lg:flex-row md:flex-row sm:flex-row pl-5 pr-5  lg:justify-end  md:justify-end justify-start gap-6 border-b-[6px] border-[#2758A3]   w-full flex justify-end  h-fit">
                    <h2 className="text-[32px] font-semibold  text-wrap text-black">
                      {Translates?.data.data.contact}
                    </h2>
                    <img
                      src="/svg/cater.svg"
                      alt=""
                      className="w-[42px] h-[42px]"
                    />
                  </div>
                </div>
                <section className="flex relative flex-col items-start px-20 pt-3 pb-64 mt-10 max-w-full tracking-tight leading-none min-h-[517px] w-[521px] max-md:px-5 max-md:pb-24 max-md:mt-10 overflow-visible">
                  <div className="flex relative flex-col items-start mb-0 max-w-full max-md:mb-2.5">
                    <div className="flex items-center mt-10 gap-3">
                      <img
                        src={Contact.data.info.phone_icon}
                        alt=""
                        className="w-[52px] h-[36px] object-contain"
                      />
                      <div className="flex flex-col">
                        <h3 className="text-2xl text-slate-900">
                          {Translates?.data.data.phone_number}
                        </h3>
                        <p className="mt-3 text-lg text-blue-800">
                          {Contact.data.info.phone_title}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center mt-10 gap-3">
                      <img
                        src={Contact.data.info.email_icon}
                        alt=""
                        className="w-[52px] object-contain"
                      />
                      <div className="flex flex-col">
                        <h3 className="text-2xl text-slate-900">
                          {Translates?.data.data.email}
                        </h3>
                        <p className="mt-3 text-lg text-blue-800">
                          {Contact.data.info.email_title}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 mt-10">
                      <img
                        src={Contact.data.info.address_icon}
                        alt=""
                        className="w-[52px] h-[36px] object-contain"
                      />
                      <div className="flex flex-col">
                        <h3 className="text-2xl text-slate-900">
                          {Translates?.data.data.location}
                        </h3>
                        <p className="mt-3 text-lg text-blue-800">
                          {Contact.data.info.address_title}
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div className=" flex-col ml-5 w-[34%] max-md:ml-0 max-md:w-full lg:flex  hidden"></div>
          </div>
        </main>
        <div
          dangerouslySetInnerHTML={{
            __html: Contact.data.info.map,
          }}
        ></div>
        <img
          alt="bgimg"
          src="/svg/bgAnimateIcon.svg"
          className=" absolute  -right-[300px]  z-0"
          style={{ top: `calc(120vh - ${scrollPosition}px)` }}
        />
        <img
          alt="bgimg"
          src="/svg/bgAnimateIcon.svg"
          className=" absolute  left-0  z-0"
          style={{ top: `calc(75vh - ${scrollPosition}px)` }}
        />
        <Footer />
      </div>
    </>
  );
}
